import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center bg-black px-6 text-center animate-fade-in">
      <Helmet>
        <title>Siden blev ikke fundet – HEINE DESIGN</title>
      </Helmet>

      <div className="space-y-6 max-w-md">
        <div className="space-y-2">
          <span className="text-xs tracking-[0.25em] uppercase text-brand-oak font-semibold block">
            Fejl 404
          </span>
          <h1 className="text-3xl font-light tracking-tight text-white uppercase">
            Siden blev ikke fundet
          </h1>
          <div className="h-[1px] w-16 bg-brand-oak mx-auto my-4" />
        </div>

        <p className="text-sm text-brand-charcoal/80 leading-relaxed font-light">
          Beklager, men den side du leder efter findes ikke, er blevet flyttet eller er midlertidigt utilgængelig.
        </p>

        <div className="pt-4">
          <Link
            to="/"
            className="px-8 py-4 bg-brand-red text-white text-xs tracking-[0.2em] uppercase hover:bg-brand-red-dark transition-colors duration-300 rounded-none inline-block"
          >
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
